import '../bootstrap'

require('../css/user.css');
require('slick-carousel/slick/slick.css')
require('slick-carousel/slick/slick-theme.css')
require('slick-carousel/slick/slick')
require('infinite-scroll/dist/infinite-scroll.pkgd.min');

window.bindUpdateForm = function() {
    $('#userUpdateForm').ajaxForm({
        dataType : 'json',
        beforeSubmit : function(formData, jqForm, options) {
            if (params.confirmed == 0) {
                $('#usernameConfirmModal').modal('show');

                return false;
            }
            else {
                $('.btn-do-submit').html('<div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>').attr('disabled', 'disabled');
                return true;
            }
        },
        success : function(responseText, statusText, xhr, $form) {
            if (responseText.status == 'success')
                window.location = responseText.data.url;
            else {
                $('.btn-do-submit').html('Tiếp tục').removeAttr('disabled');
                displayFormErrors(responseText.errors);
            }
        }
    });

    $('#username_username, #username_fullname, #username_about').keyup(function() {
        var id = $(this).attr('id').split('_')[1];
        var value = $(this).val();

        $('.placeholder-' + id).text(value);
        if (id == 'username')
            $('.placeholder-' + id).val(generateRouteUrl('orn_web_user_view', { username : value }, true));
    });

    $('.btn-do-confirm').click(function() {
        params.confirmed = 1;
        $('#usernameConfirmModal').modal('hide');
        $('#userUpdateForm').trigger('submit');

        return false;
    })
}

window.bindFavourite = function() {
    $('#searchForm input[name=s]').keyup(delay(function () {
        var s = this.value;
        if (s.length >= 3) {
            $('.dropdown-movies .list-group').html('<div class="text-center text-muted"><div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>');
            $.getJSON(Routing.generate('orn_web_profile_creator_favourite', { s : s, type : 'movie' }), function(data) {
                var html = '';
                $.each(data.data, function (k,v) {
                    html += '<a href="#" class="list-group-item px-0 btn-like-movie' + (v.liked == 1 ? ' liked' : '') + '" data-id="' + v.id + '" data-name="' + v.name + '" data-poster="' + v.poster + '" data-token="' + v.token + '"><div class="row align-items-center"><div class="col-auto"><div class="avatar"><img src="' + v.poster + '" alt="' + v.name + '" class="avatar-img rounded"></div></div><div class="col ml-n2"><h4 class="text-body mb-1">' + v.name + '</h4><p class="small text-muted mb-0">' + v.alias + '</p></div><div class="col-auto col-heart text-danger">' + (v.liked == 1 ? '<i class="icon-heart"></i>' : '') + '</div></div></a>';
                });

                $('.dropdown-movies .list-group').html(html);
            })
        }

    }, 1000));

    $('body').on('click', '.btn-like-movie', function() {
        var btn = $(this);
        var token = btn.data('token');
        var id = btn.data('id');
        var name = btn.data('name');
        var poster = btn.data('poster');

        if (btn.hasClass('liked'))
            doMovieRemove(id);
        else
            doMovieAdd(id, name, poster, token);

        $.ajax({
            url : Routing.generate('orn_web_movie_action', { action : 'like', id : id }),
            method : 'POST',
            dataType : 'json',
            data : { _token : token },
            success : function() {

            }
        });

        return false;
    });

    $.each(likes, function(k,v) {
        doMovieAdd(v.id, v.name, v.poster, v.token);
    })
}

window.bindInfiniteScroll = function(isAutoLoad) {
    var options = {
        path: params.url + '?page={{#}}',
        append: '.activity',
        history: false,
        status: '.page-load-status'
    };
    if (isAutoLoad == false) {
        options.button = '.btn-view-more';
        options.scrollThreshold = false;
    }

    var $container = $('.card-infinite').infiniteScroll(options);
    $container.on('history.infiniteScroll', function () {
        dataLayer.push({
            'event': 'virtualPageView',
            'virtualUrl': location.pathname
        });
    });
    $container.on('load.infiniteScroll', function (event,response, path) {
        var text = $(response).text();
        if (!$.trim(text)) {
            $container.infiniteScroll('destroy');
            $('.page-load-status .infinite-scroll-request').hide();
            $('.page-load-status .infinite-scroll-last').show();
        }
    });
}

window.bindGridSlick = function() {
    $('.grid').slick({
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });
}

window.doHandlePhoneUpdateForm = function(isModal) {
    var $phoneUpdateForm = $('#phoneUpdateForm');
    $phoneUpdateForm.ajaxForm({
        dataType : 'json',
        beforeSubmit :  function(formData, jqForm, options) {
            $('.btn-do-submit', jqForm).addClass('disabled').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="sr-only">Loading...</span>');
        },
        success : function(responseText, statusText, xhr, $form)  {
            $('.btn-do-submit', $phoneUpdateForm).html('Gửi mã xác thực').removeAttr('disabled').removeClass('disabled');
            if (responseText.status == 'success') {
                clearFormErrors($phoneUpdateForm);

                $('.btn-user-phone').text(responseText.data.phone);

                if (isModal == true) {
                    $('#phone-step-update').slideUp();
                    $('#phone-step-verify').slideDown();
                }
                else {
                    $('#phoneVerifyModal').modal('show');
                }
            }
            else {
                displayFormErrors(responseText.errors, $phoneUpdateForm);
                if (responseText.code == 'requested')
                    $('#phoneVerifyModal').modal('show');
            }
        }
    });
}

window.doHandlePhoneVerifyForm = function() {
    $('#phoneVerifyForm').ajaxForm({
        dataType : 'json',
        beforeSubmit :  function(formData, jqForm, options) {
            $('.btn-do-verify', jqForm).addClass('disabled').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="sr-only">Loading...</span>');
        },
        success : function(responseText, statusText, xhr, $form)  {
            var block = $('#phone-step-verify');

            if (responseText.status == 'success') {
                $('input[name=code]', block).removeClass('is-invalid');
                $('.invalid-feedback', block).addClass('d-none').removeClass('d-block');
                $('.form-error-message', block).text('');

                $('#phoneVerifyModal').modal('hide');
                window.location.reload();
            }
            else {
                $('.btn-do-verify', $form).removeClass('disabled').text('Xác thực');
                $('input[name=code]', block).addClass('is-invalid');
                $('.invalid-feedback', block).addClass('d-block').removeClass('d-none');
                $('.form-error-message', block).text(responseText.msg);
            }
        }
    });
}

window.bindAvatarForm = function() {
    $('.btn-avatar-update').on('click', function() {
        $('#user_avatar_file').trigger('click');

        return false;
    });

    $('.btn-cover-update').on('click', function() {
        $('#user_cover_fileCover').trigger('click');

        return false;
    });

    $('#user_avatar_file').change(function() {
        $('#userAvatarForm').ajaxSubmit({
            dataType : 'json',
            beforeSubmit : function(formData, jqForm, options) {
                $('.btn-avatar-update').html('<div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>').addClass('disabled');

                return true;
            },
            success : function(responseText, statusText, xhr, $form) {
                $('.btn-avatar-update').html('<i class="fe fe-camera"></i>').removeClass('disabled');

                if (responseText.status == 'success') {
                    handleUploadSuccess(responseText.data);
                }
                else {
                    handleUploadErrors(responseText.errors);
                }
            }
        });
    });

    $('#user_cover_fileCover').change(function() {
        $('#userCoverForm').ajaxSubmit({
            dataType : 'json',
            beforeSubmit : function(formData, jqForm, options) {
                $('.btn-cover-update').html('<div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>').addClass('disabled');

                return true;
            },
            success : function(responseText, statusText, xhr, $form) {
                $('.btn-cover-update').html('<i class="fe fe-camera"></i> Cập nhật ảnh bìa').removeClass('disabled');

                if (responseText.status == 'success') {
                    handleUploadSuccess(responseText.data);
                }
                else {
                    handleUploadErrors(responseText.errors);
                }
            }
        });
    });
}

function doMovieAdd(id, name, poster, token) {
    html = '<div id="movie-' + id + '" class="col-lg-2 col-sm-3 col-4 item btn-like-movie liked" data-id="' + id + '" data-token="' + token + '"><div class="mb-4"><a href="#" title="' + name + '" class="position-relative d-block"><i class="fe fe-x remove-icon"></i><img alt="' + name + '" src="' + poster + '" class="img-fluid rounded border"></a></div></div>';

    $('.btn-like-movie[data-id="' + id + '"] .col-heart').html('<i class="icon-heart"></i>');
    $('.btn-like-movie[data-id="' + id + '"]').addClass('liked');
    $('#movies').prepend(html);
    doDetectButtonText();
}

function doMovieRemove(id) {
    $('#movie-' + id).remove();
    $('.btn-like-movie[data-id="' + id + '"] .col-heart').html('');
    $('.btn-like-movie[data-id="' + id + '"]').removeClass('liked');
    doDetectButtonText();
}

function doDetectButtonText() {
    if ($('#movies .item').length == 0)
        $('.btn-do-continue').text('Bỏ qua');
    else
        $('.btn-do-continue').text('Hoàn thành');
}

function handleUploadSuccess(data) {
    $('.btn-do-continue').text('Tiếp tục');
    $('.form-errors').html('');

    $('#placeholder-avatar').attr('src', data.avatar);
    $('#placeholder-cover').attr('src', data.cover);
}

function handleUploadErrors(errors) {
    var errorsHtml = '';
    for (key in errors.fields) {
        errorsHtml += '<p class="invalid-feedback mb-0 d-block"><i class="fe fe-alert-circle"></i> ' + errors.fields[key] + '</p>';
    }

    $('.form-errors').html(errorsHtml);
}